const CSV_TIME_PATTERN = /^(?:[0-9]|0[0-9]|1[0-9]|2[0-5]):[0-5][0-9]$|^26:00$/

const isValidCsvTime = value =>
  typeof value === 'string' && CSV_TIME_PATTERN.test(value)

export default isValidCsvTime
